<template>
    <div id="VehicleList">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div v-if="permitValue != undefined">
            <div class="btn-groups text-right mb-3 border-bottom pb-3">
                <a v-if="hideButton === false" href="javascript:void(0)" class="btn btn-secondary" v-on:click="openModal()" >
                    <i class="fp-import"></i> Import
                </a>
                <button type="button" class="btn btn-secondary" v-on:click="exportCheck()" >
                    <i class="fp-export"></i> Export
                </button>
                <a  href="javascript:void(0)" v-if="addPermit && hideButton === false" class="btn btn-primary" v-on:click="addPermitForAsset()" >
                    <i class="fp-add"></i>    Add
                </a>
            </div>
            <div class="bg-white data-table p-0">
                <vue-good-table
                    ref="listPermitTable"
                    mode="remote"
                    title="Permit"
                    @on-row-click="onRowClick"
                    @on-page-change="onPageChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    @on-sort-change="onSortChange"
                    @on-select-all="onSelectAll"
                    @on-selected-rows-change="selectionChanged"
                    :totalRows="totalRecords"
                    :columns="columns"
                    :rows="rows"
                    :pagination-options="{
                        enabled: (totalRecords > serverParams.perPage ? true:false),
                        position: 'bottom',
                        perPage: perPage,
                        perPageDropdown:dropDownPerPage,
                        dropdownAllowAll: false,
                    }"
                    :select-options="{
                    enabled: permit_value,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: 'custom-class',
                    selectionText: 'rows selected',
                    clearSelectionText: 'clear',
                    }"
                    :search-options="{
                    enabled: false,
                    }">
                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                        <div :key="key">
                            <div v-if="addPermit === true && props.column.field == 'action'" class='text-center'>
                                <template v-if="props.row.status.toLowerCase() != 'cancelled'">
                                    <router-link title="Edit Asset Type" class="fp-edit" v-bind:to="{name: 'VehiclePermitEdit',params:{id:props.row.id,flag:'fromAsset'},query:{fromUrl:fromUrl}}"></router-link>
                                </template>
                            </div>
                            <div v-else>
                                {{props.formattedRow[props.column.field]}}
                            </div>
                        </div>
                    </template>
                    <div slot="selected-row-actions">
                        <template  v-if="permit_value">
                            <button id="deleteVehicleTypeBtn" v-on:click.prevent="VehiclePermitDelete" class="btn btn-primary">Delete</button>
                        </template>
                    </div>
                </vue-good-table>
            </div>
        </div>
        <div id="page-content-wrapper" class="admin-content-area" v-else>
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> {{pageTitle}}</div>
                    <div class="web-action-btn">
                        <!-- Button for Clear Cache -->
                        <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                        <button v-if="hideButton === false && canProcessPermit" id="processPermit" v-on:click.prevent="openProcessModal" class="btn btn-secondary"> <i class="fp-process"> </i> Process / Unpost</button>
                        <a v-if="hideButton === false && addPermit" href="javascript:void(0)" class="btn btn-secondary" v-on:click="openModal()" >
                            <i class="fp-import"></i> Import
                        </a>
                        <button type="button" class="btn btn-secondary" v-on:click="exportCheck()" >
                            <i class="fp-export"></i> Export
                        </button>
                        <router-link v-if="addPermit && hideButton === false" class="btn btn-primary" v-bind:to="{name: 'VehiclePermitCreate',params:{flag:'fromList'}}" >
                            <i class="fp-add"></i>    Add
                        </router-link>
                    </div>
                    <div class="mobile-action-btn elipse-btn">
                        <button type="button" class="btn btn-elipse" data-toggle="dropdown" data-toggle-position="left" aria-expanded="false" v-on:click.prevent="myFunction">
                            <i class="fp-ellipsis-v"></i>
                        </button>
                        <div id="myDropdown" class="dropdown-content">
                            <ul>
                                <li> <a v-if="hideButton === false" href="javascript:void(0)" v-on:click="openModal()"> Import </a> </li>
                                <li> <a v-on:click="exportCheck()"> Export</a></li>
                                <li> <router-link v-if="addPermit && hideButton === false" v-bind:to="{name: 'VehiclePermitCreate',params:{flag:'fromList'}}"> Add</router-link> </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content asset-permit-lists">
                        <div class="btn-groups badge-buttons text-left mb-3">
                            <div id="divTabMenu" class="btn-group rental-btn-grup-left" role="group" aria-label="Basic example">
                                <button type="button" id="getallVehicleList" v-on:click="getAllVehicleList(this)" :class="'btn btn-secondary '+all"> All </button>
                                <button type="button" id="getentryVehicleList" v-on:click="getEntryVehicleList(this)" :class="'btn btn-secondary '+entry"> Entry </button>
                                <button type="button" id="getprocessedVehicleList" v-on:click="getProcessedVehicleList(this)" :class="'btn btn-secondary '+processed"> Processed </button>
                                <button type="button" id="getexpiredVehicleList" v-on:click="getExpiredVehicleList(this)" :class="'btn btn-secondary '+expired"> Expired </button>
                                <button type="button" id="getcancelledVehicleList" v-on:click="getCancelledVehicleList(this)" :class="'btn btn-secondary '+cancelled"> Cancelled </button>
                            </div>
                        </div>
                        <data-table-filter-config :moduleName="'assetPermitList'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <p v-if="permitProcessBatch" id="processPermitMsg" class="alert-success p-2">Current batch {{permitBatchNum}} is processing. Please wait while we process permit !!</p>
                          <p v-if="batchError" class="alert-danger p-2" id="permitErrorBatchMsg">{{batchErrorMsg}}<button type="button" class="close close-alert" v-on:click="batchError = false;batchErrorMsg = ''">×</button></p>
                          <section class="bg-white data-table">
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange" :moduleName="'assetPermitList'" :position="'top'">
                                  </custom-pagination>
                                  <vue-good-table
                                      ref="listPermitTable"
                                      mode="remote"
                                      title="Permit"
                                      @on-row-click="onRowClick"
                                      @on-page-change="onPageChange"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-sort-change="onSortChange"
                                      @on-select-all="onSelectAll"
                                      @on-selected-rows-change="selectionChanged"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                      enabled: permit_value,
                                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                      selectionInfoClass: 'custom-class',
                                      selectionText: 'rows selected',
                                      clearSelectionText: 'clear',
                                      }"
                                      :search-options="{
                                      enabled: false,
                                      }">

                                      <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                          <div :key="key">
                                              <div v-if="props.column.field == 'action'">
                                                  <template v-if="props.row.status.toLowerCase() != 'cancelled'"> <!--Update Permit Only if Permit not cancelled -->
                                                      <router-link v-if="canUpdatePermit" title="Edit Asset Type" class="fp-edit" v-bind:to="{name: 'VehiclePermitEdit',params:{id:props.row.id}}"></router-link>
                                                  </template>
                                              </div>
                                              <div v-else-if="props.column.field == 'unit_no' && canViewAsset === true">
                                                  <router-link title="View Asset Details" class="color-blue"  v-bind:to="{name: 'AssetView',params:{id:props.row.vehicle_id},query:{from:'permit'}}">{{props.row.unit_no}}</router-link>
                                              </div>
                                              <div v-else-if="props.column.field == 'permit_number' && canViewPermit === true">
                                                  <router-link title="View Asset Permit" class="color-blue"  v-bind:to="{name: 'VehiclePermitView',params:{id:props.row.id}}">{{props.row.permit_number}}</router-link>
                                              </div>
                                              <div v-else>
                                                  {{props.formattedRow[props.column.field]}}
                                              </div>
                                          </div>
                                      </template>

                                      <div slot="selected-row-actions">
                                          <button v-if="showAdjustPermitBtn" id="adjustPermitBtn" v-on:click.prevent="adjustPermit" class="btn btn-primary">Adjust Permit</button>
                                          <button v-if="permit_value" id="deleteVehicleTypeBtn" v-on:click.prevent="VehiclePermitDelete" class="btn btn-primary">Delete</button>
                                      </div>
                                  </vue-good-table>
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
        <div class="modal fade invoice-modal" id="myModal" ref="myModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Select File</h5>
                    </div>
                    <div class="modal-body">
                        <form id="importFile" class="addinspectionForm">
                            <div class="form-row">
                                <div class="col form-group">
                                    <label class="control-label require mb-2" for="name">File:</label><br/>
                                    <input id="typeImage" type="file" @change="onFileChanged">
                                    <div class="field-error">{{import_error}}</div>
                                </div>
                            </div>
                            <hr class="light-hr"/>
                            <div class="form-row">
                                <div class="col form-group" v-if="fileName != ''">
                                    <p class="module-title mb-2"> Download Sample file for Permit </p>
                                    <a class="color-blue" href="javascript:void(0)" v-on:click="downloadSample()"> <i class="fp-excel color-gray"></i> {{fileName}} </a>
                                </div>
                            </div>
                            <p>&nbsp;</p>
                            <p>&nbsp;</p>
                            <template v-if="duplicatePermit.duplicate && duplicatePermit.duplicate.length > 0">
                                <label class="d-block"> Permit Not Imported For These Unit due to having same permit in same period:</label>
                                <template v-for="(permit,perKey) in duplicatePermit.duplicate">
                                    <a :key="perKey" v-if="perKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="perKey">{{permit.permit_number}}</span>
                                </template>
                                <p>&nbsp;</p>
                            </template>
                            <template v-if="duplicatePermit.unit && duplicatePermit.unit.length > 0">
                                <label class="d-block"> Permit Not Imported Because These Unit Not Available:</label>
                                <template v-for="(permit,assetKey) in duplicatePermit.unit">
                                    <a :key="assetKey" v-if="assetKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="assetKey">{{permit.unit_number}}</span>
                                </template>
                                <p>&nbsp;</p>
                            </template>
                            <template v-if="duplicatePermit.permit_type && duplicatePermit.permit_type.length > 0">
                                <label class="d-block"> These Permit Not Imported Because Permit Type Not Available:</label>
                                <template v-for="(permit,ptKey) in duplicatePermit.permit_type">
                                    <a :key="ptKey" v-if="ptKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="ptKey">{{permit.permit_type}}</span>
                                </template>
                                <p>&nbsp;</p>
                            </template>
                            <template v-if="duplicatePermit.location && duplicatePermit.location.length > 0">
                                <label class="d-block"> These Permit Not Imported Because Location Code Not Available:</label>
                                <template v-for="(permitLoc,locKey) in duplicatePermit.location">
                                    <a :key="locKey" v-if="locKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="locKey">{{permitLoc.location}}</span>
                                </template>
                            </template>
                            <template v-if="duplicatePermit.amount && duplicatePermit.amount.length > 0">
                                <label class="d-block"> Permit Not Imported Because These Unit Permit Amount Not Available:</label>
                                <template v-for="(permit,assetKey) in duplicatePermit.amount">
                                    <a :key="assetKey" v-if="assetKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="assetKey">{{permit.unit_number}}</span>
                                </template>
                                <p>&nbsp;</p>
                            </template>
                            <template v-if="duplicatePermit.date_validate && duplicatePermit.date_validate.length > 0">
                                <label class="d-block"> Permit Not Imported Because These Unit Permit Expiry Date Is Earlier Than Effective Date:</label>
                                <template v-for="(permit,assetKey) in duplicatePermit.date_validate">
                                    <a :key="assetKey" v-if="assetKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="assetKey">{{permit.unit_number}}</span>
                                </template>
                                <p>&nbsp;</p>
                            </template>
                            <template v-if="duplicatePermit.ownership && duplicatePermit.ownership.length > 0">
                                <label class="d-block"> Permit Not Imported Because These Unit Ownership is not Owned or Customer:</label>
                                <template v-for="(permit,assetKey) in duplicatePermit.ownership">
                                    <a :key="assetKey" v-if="assetKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="assetKey">{{permit.unit_number}}</span>
                                </template>
                                <p>&nbsp;</p>
                            </template>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-tertiary" id="okbutton" data-dismiss="modal"> <i class="fp-close"> </i>Cancel</button>
                        <button class="btn btn-primary" id="myButton" v-on:click="importPermit()"> <i class="fp-import"> </i> Import</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade add-extra-charge-popup" id="processModal" ref="processModal" data-backdrop="static" data-keyboard="false" aria-labelledby="processModal" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="myModal1">Process Permit</h5>
                    </div>
                    <div class="modal-body">
                        <form id="SelectDates" class="addinspectionForm">
                            <div class="form-row row-cols-md-1 row-cols-1">
                                <!-- <div class="col form-group">
                                    <label class="control-label require">Effective Date</label>
                                    <div class="input-group">
                                        <date-picker placeholder="MM/DD/YYYY" id="effective_date" name="effective_date" v-model="effective_date" :config="optionsDate" aria-describedby="basic-addon3" class="cal-icon"></date-picker>
                                        <label for="effective_date" class="fp-calendar input-calender-icon"></label>
                                    </div>
                                    <div class="field-error">{{effective_date_error_msg}}</div>
                                </div> -->
                                <div class="col form-group">
                                    <label class="control-label require">Process Date</label>
                                    <v-select v-model="processed_date" name="processed_date" placeholder="Select Date."
                                            label="text"
                                            :options="dateArr">
                                    </v-select>
                                    <div class="field-error">{{processed_date_error_msg}}</div>
                                </div>
                                <div class="col form-group">
                                    <div class="custom-checkbox">
                                        <label class="checkbox-custom">  Generate Invoice <input type="checkbox" v-model="invoice_required" id="invoice_required" name="invoice_required" :disabled="true">
                                        <span class="checkmark"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-primary" id="addProcessPermitBtn" v-on:click="processPermit(false)">
                            <i class="fp-submit"></i> Process
                        </button>
                      <button v-if="canUnpost" class="btn btn-primary" id="addProcessPermitBtn" v-on:click="processPermit(true)">
                        <i class="fp-submit"></i> Unpost
                      </button>
                        <button type="button" class="btn btn-tertiary" id="cancelprocessPermitBtnBtn" v-on:click="hideProcessModal()">
                            <i class="fp-close"></i> Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade permit-message-modal" id="permit-message-modal" ref="permitMessageModal" data-backdrop="static" data-keyboard="false" aria-labelledby="permitMessageModal" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Message</h5>
                        <button type="button" class="close" id="btnPermitModalMessageClose" v-on:click="hidePermitMessageModal()">&times;</button>
                    </div>
                    <div class="modal-body">
                            <p>&nbsp;</p>
                            <p>Following Asset Permit cannot be removed : </p>
                            <template v-if="permitNumberArr.length > 0">
                                <template v-for="(permitNo,key) in permitNumberArr">
                                    <a :key="key" v-if="key > 0">&nbsp;&nbsp; | &nbsp;&nbsp;</a><span :key="key"> {{permitNo}}</span>
                                </template>
                            </template>
                    </div>
                    <div class="modal-footer">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import EventBus from "./event-bus";
    import Vue from "vue";

    
    



    import {commonMixins} from '../mixins/commonMixins';
    import {dataTableMixins} from '../mixins/dataTableMixins';
    import moment from 'moment';
    let msgServer;

    export default {
        name: "VehicleList",
        mixins:[commonMixins,dataTableMixins],
        props: {
            permitValue: {
                type: String,
                required: false,
                default:undefined
            }
        },
        data: () => ({
            pageTitle : "Asset Permit List",
            hideButton: false,
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: '#Unit',
                    field: 'unit_no',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit Number", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: '#Permit',
                    field: 'permit_number',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Permit Number", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },

                {
                    label: 'Permit Type',
                    field: 'permit_type',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Permit Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Customer',
                    field: 'customer',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Location',
                    field: 'location',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Location", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Amount',
                    field: 'amount',
                    fpFieldType:"integer",
                    hidden:false,
                    type:'number',
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Amount", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Allowance',
                    field: 'allowance',
                    fpFieldType:"integer",
                    hidden:false,
                    type:'number',
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Allowance", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Permit Status',
                    field: 'status',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterDropdownItems: ['Entry','Processed','Expired','Cancelled'],
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
                {
                    label: 'Effective Date',
                    field: 'effective_date',
                    hidden:false,
                    fpFieldType:"date",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Expiry Date',
                    field: 'expiry_date',
                    fpFieldType:"date",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Cancel Date',
                    field: 'cancel_date',
                    fpFieldType:"date",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Owner',
                    field: 'owner',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Owner", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
            ],
            rows: [],
            totalRecords: 0,
            asset_value: false,
            loading:false,
            permit_value:false,
            addPermit:false,
            assetId:"",
            selectedFile:"",
            optionsDate: {
                format: 'MM/DD/YYYY',
                useCurrent: false,
                toolbarPlacement:'bottom',
                widgetPositioning: {
                horizontal: 'auto',
                vertical: 'bottom'
                },
            },
            effective_date:'',
            effective_date_error_msg:'',
            invoice_required:true,
            duplicatePermit:[],
            reqeustSent:0,
            fileName:'',
            file:'',
            action:'list',
            canUpdatePermit:false,
            canViewAsset:false,
            pageKey:"_permit_list_",
            permitNumberArr:[],
            showAdjustPermitBtn:false,
            dateArr:[],
            import_error:'',
            canViewPermit:false,
            processed_date:'',
            processed_date_error_msg:'',
            fromUrl:"",
            canProcessPermit:false,
            batchProcess:0,
            batchNum:"",
            batchError:false,
            batchErrorMsg:"",
            permitProcessBatch:0,
            permitBatchNum:"",
            permitBatchId:0,
            canUnpost: false,
            all: '',
            entry: '',
            processed: '',
            expired: '',
            cancelled: '',
            selectedStatus: ''
        }),
        metaInfo () {
            if (this.permitValue == undefined) {
                return {
                    title: "Asset Permit List | " +process.env.COPYRIGHT_NAME
                }
            }
        },
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_asset_permit') {
                            self.cantAccessPage = true;
                        } else if (permissions[i].name == 'add_asset_permit') {
                            self.addPermit = true;
                            self.canUpdatePermit = true;
                        } else if (permissions[i].name == 'delete_asset_permit') {
                           if(self.$route.query.flag == 'permitEntryReport' || self.$route.query.flag == 'unitPermitReport' ){
                              self.permit_value = false;
                          } else{
                              self.permit_value = true;
                          }
                        } else if (permissions[i].name == 'view_asset') {
                            self.canViewAsset = true;
                        } else if (permissions[i].name == 'view_asset_permit') {
                            self.canViewPermit = true;
                        } else if (permissions[i].name == 'process_asset_permit') {
                            self.canProcessPermit = true;
                        }else if (permissions[i].name == 'unpost_gl') {
                          self.canUnpost = true;
                        }
                    }
                }

            }
        },
        created: function() {
          $(document).on("click", ".generate-invoice-link", (elm) => {
              elm.preventDefault();
              var id = $(elm.target).attr("data-row-id");
              if ( id != undefined && id != null ) {
                  this.$router.push({ name: 'PermitInvoiceCreate', query: { permit_id : id }});
              }
          });

          //show invoice link if invoice already generated
          $(document).on("click", ".show-invoice-link", (elm) => {
              elm.preventDefault();
              var id = $(elm.target).attr("data-row-invoice-id");
              if ( id != undefined && id != null ) {
                  let routeData = this.$router.resolve({ name:"PermitInvoice",params:{ id: id}});
                  window.open(routeData.href,"_blank");
              }
          })
        },
        beforeDestroy(){
            this.$root.$off('load_permit');
        },
        mounted: function() {
            var self = this;
            self.getLastDateofmonth();console.log("permit list"+window.location.href);
              self.fromUrl = btoa(window.location.pathname);
             if(self.$route.query.flag == 'permitEntryReport' || self.$route.query.flag == 'unitPermitReport' ){
               self.hideButton = true;
               if(self.$route.query.flag == 'permitEntryReport'){
                 self.pageTitle = "Permit in Entry Status";
                 for (let index = 0; index < this.columns.length; index++) {

                  if(this.columns[index].field == 'status'){
                      this.$set(this.columns[index], 'hidden', true);
                  }

              }
               }else{
                  self.pageTitle = "Unit Permit Detail";
               }

              for (let index = 0; index < this.columns.length; index++) {

                  if(this.columns[index].field == 'action'){
                      this.$set(this.columns[index], 'hidden', true);
                  }
              }
            }
            // this.$root.$on('load_permit', () => {
                // var path = window.location.pathname;
                // var asset = path.split("/");
                // self.assetId = asset[3];
                // self.flag = 'assetComponent';
                // self.permitValue = 'loadList';

                // //for now hide unit and name datatable column
                // for (let index = 0; index < this.columns.length; index++) {

                //     if(this.columns[index].field == 'unit_no'){
                //         this.$set(this.columns[index], 'hidden', true);
                //     }

                // }
                // self.getPermissions();
                // self.loadList();
            // });
            //when component list directly call from url instead of in view page than call permission request
            $("#divTabMenu button").removeClass("active");
            var prevSelectedTab = localStorage.getItem("asset_permit_list_prev_tab");
            console.log('prevSelectedTab:', prevSelectedTab)
            if ( prevSelectedTab == null || prevSelectedTab == 'all_tab') {
                self.selectedStatus = "all";
                self.all = 'active';
                localStorage.setItem('asset_permit_list_prev_tab', 'all_tab');
                $("#getallVehicleList").addClass("active");

            } else if( prevSelectedTab == 'entry_tab' ) {
                self.selectedStatus = "entry";
                self.entry = 'active';
                localStorage.setItem('asset_permit_list_prev_tab', 'entry_tab');
                $("#getentryVehicleList").addClass("active");
            } else if( prevSelectedTab == 'processed_tab' ){
                self.selectedStatus = "processed";
                self.processed = 'active';
                localStorage.setItem('asset_permit_list_prev_tab', 'processed_tab');
                $("#getprocessedVehicleList").addClass("active");
            } else if(  prevSelectedTab == 'expired_tab'){
                self.selectedStatus = "expired";
                self.expired = 'active';
                localStorage.setItem('asset_permit_list_prev_tab', 'expired_tab');
                $("#getexpiredVehicleList").addClass("active");
            } else {
                self.selectedStatus = "cancelled";
                self.cancelled = 'active';
                localStorage.setItem('asset_permit_list_prev_tab', 'cancelled_tab');
                $("#getcancelledVehicleList").addClass("active");
            }

            if ( self.permitValue == undefined ) {
                // self.getPermissions();
            }else{
                var path = window.location.pathname;
                var asset = path.split("/");
                self.assetId = asset[3];
                self.flag = 'assetComponent';
                self.permitValue = 'loadList';

                //for now hide unit and name datatable column
                for (let index = 0; index < this.columns.length; index++) {

                    if(this.columns[index].field == 'unit_no'){
                        this.$set(this.columns[index], 'hidden', true);
                    }

                }

                // self.getPermissions();
                self.loadList();
            }
            self.getPermissions();

        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listPermitTable.unselectAllInternal();
            },
        selectionChanged(param) {
            var self = this;
            self.serverParams.selectedAll = false;
            if(param.selectedRows.length == 100) {
              EventBus.$emit('clear-selection', false);
            } else {
              EventBus.$emit('clear-all-flags', false);
            }
            var rowData = self.$refs['listPermitTable'].selectedRows;
            self.showAdjustPermitBtn = false;
            if (rowData.length == 1) {
                if (rowData[0].status.toLowerCase() != "cancelled" && rowData[0].status.toLowerCase() != "expired") {
                    self.showAdjustPermitBtn = true;
                }
            }
            return;
        },

        loadList() {

            //remove row of details if any open
            $('table tr.invoiceDetails').remove();

            var self = this;

            var permitStatus = '';
                if(self.$route.query.flag && self.$route.query.flag == "permitEntryReport"){
                  permitStatus = 'Entry';

                }

            if( self.permitValue == 'dontLoadList' ){
                return;
            }
            var data = this.$refs['listPermitTable'].selectedRows;
            var selectedRows = [];

            for (var i = 0; i < data.length; i++) {
                selectedRows.push(self.$refs['listPermitTable'].selectedRows[i].id)
            }

            self.loading = true;
            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                vehicle_id: self.assetId,
                sort: self.serverParams.sort,
                all:self.serverParams.selectedAll,
                selectedRows:selectedRows,
                action:self.action,
                permitStatus : permitStatus,
                selectedStatus : self.selectedStatus,
                // exportFiltered: self.exportFilteredFlag
            };
            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/vehiclepermit/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        if ( self.action == "delete" ) {

                            self.action = "list";
                            $("#deleteVehicleTypeBtn").val("Delete");
                            self.permitNumberArr = [];
                            if (data.content.permitArr && data.content.permitArr.length > 0) {
                                //agreement policy mapped message
                                self.permitNumberArr = data.content.permitArr;
                                $("#permit-message-modal").modal("show");
                            }
                            if(self.permitValue == undefined){
                                self.$refs.filterComponent.clearSelectAll();
                            }
                            self.loadList();
                            if(self.permitValue == undefined){
                                EventBus.$emit('clear-all-flags', false);   //hide alert of selection
                            }

                        }else if ( self.action == "export" ||  self.action == "export_queue") {
                            if ( data.code == "201" ) {
                                alert(data.message);
                            } else {
                                if ( self.action == "export" ) {
                                    self.excel = data.content.web;
                                    var save = document.createElement("a");
                                    save.href = self.excel;
                                    save.download = data.content.web;
                                    save.target = "_blank";

                                    document.body.appendChild(save);
                                    save.click();
                                    document.body.removeChild(save);

                                } else {

                                    self.batchProcess = 1;
                                    self.batchNum = data.content;
                                }
                            }
                            self.action = "list";
                            // self.loadList();
                        }else{
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                            if (data.content.batchId != undefined && data.content.batchId != null){
                                self.permitBatchId = data.content.batchId;
                                self.permitBatchNum = data.content.batch;
                                self.permitProcessBatch = 1;
                                self.checkBatchStatus();
                            }
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if(self.action == "delete"){
                        self.generateStatusCodeMessage(jqXHR,true,'delete-permit-list')
                    }else{
                        self.generateStatusCodeMessage(jqXHR,false,'permit-list')
                    }
                }
            });
        },
        VehiclePermitDelete() {
            var self = this;
            var error = true;
            //if selected permit in entry status then allow to delete
            var data = this.$refs['listPermitTable'].selectedRows;
            var selectedRows = [];

            for (var i = 0; i < data.length; i++) {
                selectedRows.push(this.$refs['listPermitTable'].selectedRows[i].status.toLowerCase())
            }
            //check all values in array are equal or not
            const allEqual = arr => arr.every( v => v === arr[0] );
            var found = allEqual(selectedRows);
            if ( found ) {
                if (selectedRows[0] == "entry") {
                    error = false;
                }
            }

            if (error) {
                this.$swal('','Please select records with Permit Status - Entry','info');
                return;
            }else{
                self.$swal({
                    title: 'Are you sure that you want to delete this Asset Permit?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        this.action = "delete";
                        $("#deleteVehicleTypeBtn").val("Deleting ...");

                        this.loadList();
                    } else {
                      console.log("no");
                    }
                });
            }
        },
        onFileChanged (event) {
                const file = event.target.files[0]
                console.log(event.target);
                var self = this;
                self.selectedFile = file;
                self.notfound = false;
                self.notFoundArr = [];
                console.log(self.selectedFile);
                self.import_error = '';
            },
        
            openModal: function(){
                var self = this;
                console.log(self.selectedFile);
                self.selectedFile = "";
                self.duplicatePermit = [];
                $("#typeImage").val('');
                self.import_error = '';

                $.ajax({
                    url:
                    process.env.ROOT_API +
                    "/permit-excel/generate",
                    type: "POST",
                    crossDomain: true,
                    dataType: "json",
                    headers: this.ajxHeaders,

                    success: function(data) {
                        self.loading = false;
                        console.log(data);
                        self.fileName = data.content.file;
                        self.file = data.content.web;

                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'permit-import')

                    }
                });

                $('#myModal').modal('show');
            },
             downloadSample(){
                var self = this;
                // alert(self.file);
                // console.log()
                var docPath = self.file;
                var save = document.createElement('a');
                save.href = docPath;
                save.download = docPath;
                save.target = '_blank';
                document.body.appendChild(save);
                save.click();
                document.body.removeChild(save);
            },
            importPermit: function(){
                var self = this;
                var formData = new FormData();
                formData.append('myFile', self.selectedFile);

                self.loading = true;
                $('#myButton').text('Fetching...');
                $('#myButton').prop('disabled',true);
                $.ajax({
                url: process.env.ROOT_API + "/permit/import",
                type: "POST",
                // data: {name: self.name, code: self.code, is_default: self.checkboxValue, id: segments[3]},
                data: formData,
                headers: this.ajxHeaders,
                crossDomain: true,
                processData: false,
                contentType: false,
                dataType: "json",
                success: function (data) {
                    $('#myButton').text('Import');
                    $('#myButton').prop('disabled',false);
                    self.import_error = '';
                    self.loading = false;
                    if (data.code == 201) {
                        self.import_error = data.message;
                        return;
                    }
                    if (data.status == "success") {

                        if ( Object.keys(data.duplicate).length > 0){

                            self.duplicatePermit = data.duplicate;
                            console.log(self.duplicatePermit);
                        }else{
                            if(data.content != false){
                                self.$swal('',data.content+" Records imported",'success');
                            }
                            self.error = "";
                                $('#myModal').modal('hide');
                                self.loadList();
                        }

                    }
                },
                error: function (jqXHR, exception) {
                    $('#myButton').text('Import');
                    $('#myButton').prop('disabled',false);
                   self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'permit-import-error')
                }
            });
            },
            openProcessModal: function(){
                var self = this;

                self.effective_date = '';
                self.processed_date = '';
                self.effective_date_error_msg = '';
                self.processed_date_error_msg = '';
                self.invoice_required = true;
                $("#processModal").modal('show');
            },
            hideProcessModal(){
                var self = this;
                self.effective_date = '';
                self.processed_date = '';
                self.effective_date_error_msg = '';
                self.processed_date_error_msg = '';
                self.invoice_required = true;
                $("#processModal").modal('hide');
            },

            processPermit: function(isUnpost){
                
                var self = this;
                self.effective_date_error_msg = '';
                self.processed_date_error_msg = '';
                var error = false;
                
                if ( self.processed_date == null || self.processed_date == "" || !self.processed_date){
                    self.processed_date_error_msg = "Process Date Required.";
                    error = true;
                }

                if (!error) {
                    $("#addProcessPermitBtn").val("Processing ...");
                    $("#addProcessPermitBtn").prop("disabled", true);

                    $.ajax({
                        url: process.env.ROOT_API + "/permit/process",
                        type: "POST",
                        data: {
                        // fields:this.$refs['listPermitTable'].selectedRows,
                        process_date:self.processed_date,
                        invoice_required:self.invoice_required,
                        isReverse: isUnpost
                        },
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            // setTimeout(function () {
                            // $(".alert-success").removeClass("show");
                            //     $(".alert-success").addClass("hide");
                            // }, 10000);
                            // setTimeout(function () {
                            //     $("#deleteVehicleTypeBtn").val("Delete");
                            // }, 10000);

                            if (data.code == '200') {
                                $("#processModal").modal('hide');
                                if (data.content.batch != undefined && data.content.batch != "") {
                                    if (data.content.batch_id != undefined && data.content.batch_id != null) {
                                        if (data.content.batch_id > 0) {
                                            self.permitBatchId = data.content.batch_id;
                                            self.permitBatchNum = data.content.batch;
                                            self.permitProcessBatch = 1;
                                            self.checkBatchStatus();
                                        }
                                    }
                                }
                                // self.loadList();
                            }
                            $("#addProcessPermitBtn").val("Process");
                            $("#addProcessPermitBtn").prop("disabled", false);
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            $("#addProcessPermitBtn").val("Process");
                            $("#addProcessPermitBtn").prop("disabled", false);
                            self.generateStatusCodeMessage(jqXHR,true,'permit-import-error')

                        }
                    });
                }
            },
            onRowClick(params) {
                var self = this;

                if ( $(params.event.target).hasClass("vgt-checkbox-col") || $(params.event.target).hasClass("glyphicon glyphicon-eye-open")) {
                   return;
                }

                if ( self.reqeustSent == 1 ) {
                   return;
                }

                //if data already available than remove it
                if ( $(params.event.target.closest('.clickable').nextSibling).hasClass("invoiceDetails")) {
                    $(params.event.target.closest('.clickable').nextSibling).remove();
                    return;
                }

                //generate html
                var html = '<tr class="invoiceDetails"><td colspan="11"><table aria-describedby="table" class="table">';
                    html += '<tr><th>#Permit</th><th>Permit Type</th><th>Customer</th><th>Amount</th><th>Allowance</th><th>Amortized Amount</th><th>Effective Date</th><th>Expiry Date</th><th>Description</th><th>Action</th></tr>';

                var fields = {
                    permit_id:params.row.id,
                    flag:"permit"
                };
                self.reqeustSent = 1;

                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/permit-mapper/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {

                        self.reqeustSent = 0;
                        self.loading = false;
                        if ( data.code == 200 ) {

                            //check data records
                            if ( data.content.row.length > 0 ) {

                                for ( var j=0; j<data.content.row.length; j++ ) {
                                    if ( data.content.row[j].invoiceFlag == 1 ) {

                                        if ( data.content.row[j].invoice_id != "-" ) {
                                            html += '<tr><td>'+data.content.row[j].permit_number+'</td><td>'+data.content.row[j].permit_type+'</td><td>'+data.content.row[j].customer+'</td><td>'+data.content.row[j].amount+'</td><td>'+ data.content.row[j].allowance +'</td><td>'+data.content.row[j].amortized_amount+'</td><td>'+data.content.row[j].from_date+'</td><td>' +data.content.row[j].to_date+'</td><td>' + data.content.row[j].mapper_description +'</td><td><a class="color-blue show-invoice-link" title="View Invoice" data-row-invoice-id="'+ data.content.row[j].invoice_id +'" href="javascript:void(0)">'+ data.content.row[j].invoice_number  +'</a></td></tr>';
                                        }else{
                                            html += '<tr><td>'+data.content.row[j].permit_number+'</td><td>'+data.content.row[j].permit_type+'</td><td>'+data.content.row[j].customer+'</td><td>'+data.content.row[j].amount+'</td><td>'+ data.content.row[j].allowance +'</td><td>' +data.content.row[j].amortized_amount+'</td><td>'+data.content.row[j].from_date+'</td><td>' +data.content.row[j].to_date+'</td><td>' + data.content.row[j].mapper_description +'</td><td><a class="btn btn-success waves-effect generate-invoice-link" data-row-id="'+ data.content.row[j].id +'" href="javascript:void(0)">Generate Invoice</a></td></tr>';
                                        }

                                    }else{
                                        html += '<tr><td>'+data.content.row[j].permit_number+'</td><td>'+data.content.row[j].permit_type+'</td><td>'+data.content.row[j].customer+'</td><td>'+data.content.row[j].amount+'</td><td>'+ data.content.row[j].allowance +'</td><td>'+data.content.row[j].amortized_amount+'</td><td>'+data.content.row[j].from_date+'</td><td>' +data.content.row[j].to_date+'</td><td>' + data.content.row[j].mapper_description +'</td><td>-</td></tr>';
                                    }
                                }

                            } else {

                                html += '<tr><td colspan="11">No record found.</td></tr>';
                            }

                            html += '</table></td></tr>';
                            $(html).insertAfter(params.event.target.closest('.clickable'));
                        }
                    },
                    error: function (jqXHR, exception) {

                        self.reqeustSent = 0;

                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'get-permit-mapper')
                    }
                });
            },
            exportCheck: function() {
                var count = 0;
                var actionFlag = "";
                var data = this.$refs['listPermitTable'].selectedRows;
                // console.log(data.length);return;
                count = data.length;
                if(this.serverParams.selectedAll == true){
                    actionFlag = "";
                }else if(count != 0 && count <= 100){
                    actionFlag = "export";
                }
                this.exportReports(actionFlag);
            },
            addPermitForAsset: function(){
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");

                var url = '&assetId='+segments[3]+'&redirectFrom=assetView';
                self.$router.push({ name: 'VehiclePermitCreate', query: { data : btoa(url) }});
            },
            hidePermitMessageModal() {
                var self = this;
                $("#permit-message-modal").modal("hide");
                self.permitNumberArr = [];
            },
            adjustPermit() {
                var self = this;
                var data = this.$refs['listPermitTable'].selectedRows;
                if (data.length == 1) {
                    var permitId = data[0].id;
                    self.$router.push({ name: 'PermitAdjust', params: { id : permitId }});
                }
            },
            getLastDateofmonth:function(){
                var self = this;

                var date = new Date();
                // var newdate = new Date();
                var arr = [];
                for(var i = 3; i >= 0;i--){
                    var momentDate = moment(date).subtract(i, 'months').format('MM/DD/YYYY');
                    arr.push(moment(momentDate).endOf('month').format('MM/DD/YYYY'));
                    // arr.push(moment(date).subtract(i, 'months').format('MM/DD/YYYY'));
                }
                // for(var j = 0; j <= 3;j++){
                //     var momentDate = moment(newdate).add(j, 'months').format('MM/DD/YYYY');
                //     arr.push(moment(momentDate).endOf('month').format('MM/DD/YYYY'));
                // }
                self.dateArr = arr;
                console.log(self.dateArr);
            },
            checkBatchStatus:function(){
                var self =  this;
                this.$sse(process.env.ROOT_API + '/check/batch-status/'+self.permitBatchId, { format: 'json' }) // or { format: 'plain' }
                .then(sse => {
                    // Store SSE object at a higher scope
                    msgServer = sse;

                    // Listen for messages without a specified event
                    sse.subscribe('', data => {
                        if ( data.status == "1") {
                            self.permitProcessBatch = 0;
                            self.loadList();
                            sse.close();
                        }else if (data.status == "2") {
                            self.permitProcessBatch = 0;
                            self.batchError = true;
                            self.batchErrorMsg = data.message;
                            sse.close();
                        }
                    });

                })
                .catch(err => {
                    // When this error is caught, it means the initial connection to the
                    // events server failed.  No automatic attempts to reconnect will be made.
                    console.error('Failed to connect to server', err);
                });
            },

            getAllVehicleList: function(){

                var self = this;
                $('#divTabMenu button').removeClass("active");
                $("#getallVehicleList").addClass("active");
                self.$refs.filterComponent.clearSelectAll();
                EventBus.$emit('clear-all-flags', false);
                self.all = 'active';
                localStorage.setItem('asset_permit_list_prev_tab', 'all_tab');
                self.entry = '';
                self.processed = '';
                self.expired = '';
                self.cancelled = '';
                self.selectedStatus = "";
                self.$nextTick(() => {
                  // Add the component back in
                  self.selectedStatus = "all";
                  self.$refs.filterComponent.onColumnFilter('cancel');
                });
                
            },

            getEntryVehicleList: function(){

                var self = this;
                $('#divTabMenu button').removeClass("active");
                $("#getentryVehicleList").addClass("active");
                self.$refs.filterComponent.clearSelectAll();
                EventBus.$emit('clear-all-flags', false);
                self.entry = 'active';
                localStorage.setItem('asset_permit_list_prev_tab', 'entry_tab');
                self.all = '';
                self.processed = '';
                self.expired = '';
                self.cancelled = '';
                self.selectedStatus = "";
                self.$nextTick(() => {
                  // Add the component back in
                  self.selectedStatus = "entry";
                  self.$refs.filterComponent.onColumnFilter('cancel');
                });
            },

            getProcessedVehicleList: function(){

                var self = this;
                $('#divTabMenu button').removeClass("active");
                $("#getprocessedVehicleList").addClass("active");
                self.$refs.filterComponent.clearSelectAll();
                EventBus.$emit('clear-all-flags', false);
                self.processed = 'active';
                localStorage.setItem('asset_permit_list_prev_tab', 'processed_tab');
                self.all = '';
                self.entry = '';
                self.expired = '';
                self.cancelled = '';
                self.selectedStatus = "";
                self.$nextTick(() => {
                  // Add the component back in
                  self.selectedStatus = "processed";
                  self.$refs.filterComponent.onColumnFilter('cancel');
                });
            },

            getExpiredVehicleList: function(){

                var self = this;
                $('#divTabMenu button').removeClass("active");
                $("#getexpiredVehicleList").addClass("active");
                self.$refs.filterComponent.clearSelectAll();
                EventBus.$emit('clear-all-flags', false);
                self.expired = 'active';
                localStorage.setItem('asset_permit_list_prev_tab', 'expired_tab');
                self.all = '';
                self.entry = '';
                self.processed = '';
                self.cancelled = '';
                self.selectedStatus = "";
                self.$nextTick(() => {
                  // Add the component back in
                  self.selectedStatus = "expired";
                  self.$refs.filterComponent.onColumnFilter('cancel');
                });
            },

            getCancelledVehicleList: function(){

                var self = this;
                $('#divTabMenu button').removeClass("active");
                $("#getcancelledVehicleList").addClass("active");
                self.$refs.filterComponent.clearSelectAll();
                EventBus.$emit('clear-all-flags', false);
                self.cancelled = 'active';
                localStorage.setItem('asset_permit_list_prev_tab', 'cancelled_tab');
                self.all = '';
                self.entry = '';
                self.processed = '';
                self.expired = '';
                self.selectedStatus = "";
                self.$nextTick(() => {
                  // Add the component back in
                  self.selectedStatus = "cancelled";
                  self.$refs.filterComponent.onColumnFilter('cancel');
                });
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/PermitList.vue